__turbopack_context__.v({
  "caret": "LessonBoardDock-module__INDaSq__caret",
  "caret-blink": "LessonBoardDock-module__INDaSq__caret-blink",
  "chevron": "LessonBoardDock-module__INDaSq__chevron",
  "collapseToggle": "LessonBoardDock-module__INDaSq__collapseToggle",
  "dock": "LessonBoardDock-module__INDaSq__dock",
  "dock-in": "LessonBoardDock-module__INDaSq__dock-in",
  "dockContent": "LessonBoardDock-module__INDaSq__dockContent",
  "dockHeader": "LessonBoardDock-module__INDaSq__dockHeader",
  "empty": "LessonBoardDock-module__INDaSq__empty",
  "notebookSlot": "LessonBoardDock-module__INDaSq__notebookSlot",
  "placeholder": "LessonBoardDock-module__INDaSq__placeholder",
  "presence": "LessonBoardDock-module__INDaSq__presence",
  "sectionTitle": "LessonBoardDock-module__INDaSq__sectionTitle",
  "thread": "LessonBoardDock-module__INDaSq__thread",
  "threadItem": "LessonBoardDock-module__INDaSq__threadItem",
  "threadLabel": "LessonBoardDock-module__INDaSq__threadLabel",
  "threadList": "LessonBoardDock-module__INDaSq__threadList",
  "threadReview": "LessonBoardDock-module__INDaSq__threadReview",
  "threadToggle": "LessonBoardDock-module__INDaSq__threadToggle",
  "writingDot": "LessonBoardDock-module__INDaSq__writingDot",
});
